import React, { ReactNode } from 'react';
import { Divider } from 'antd';
import PreviewListItem from '../PreviewListItem';
import Wrapper from '../Wrapper';

export type StudentsListProps = {
  data?: any;
  hover?: boolean;
  withBg?: boolean;
  actions?: ReactNode | string;
  fallback?: ReactNode;
  onItemClick?: (item: any) => void;
};

const TStudentsList: React.FC<StudentsListProps> = ({
  data = [],
  fallback,
  hover = true,
  withBg = false,
  onItemClick = () => {},
}) => {
  return (
    <>
      {!!data.length ? (
        data.map((item, index) => (
          <div key={index}>
            <PreviewListItem
              hover={hover}
              withBg={withBg}
              actions={item.actions}
              name={item.name}
              avatar={item.avatar}
              date={item.date}
              onItemClick={() => onItemClick(item)}
            />
            {data.length - 1 !== index && <Divider style={{ margin: 0 }} />}
          </div>
        ))
      ) : (
        <Wrapper display="flex" justifyContent="center" alignItems="center">
          {fallback}
        </Wrapper>
      )}
    </>
  );
};

export default TStudentsList;
